import {
  TestAnswerFeedbackDisplayOption,
  TestAnswerFeedbackType,
} from '@vedalib/editor/lib/elements'

import EditableProMode from 'components/Editor/cource/layout/controls/ElementControls/EditableProMode'
import TestElementChangeStateActions from 'components/Editor/cource/layout/controls/ElementControls/TestElementChangeState'
import Separator from 'components/Editor/cource/layout/controls/Separator'
import Button from 'components/uiKit/Button'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { AppMode } from 'services/Store/Project/enums'
import { t } from 'services/Translation'

import type { TestGroupingEditorActionsType, TestGroupingStateType } from './testGroupingTypes'

const TestGroupingEditorActions: TestGroupingEditorActionsType = ({
  element: { value },
  customMode,
  mode,
  setState,
  state,
  setAppMode,
}) => {
  const isPro = mode.editorMode === AppMode.pro
  const showSeparator =
    value.displayFeedback === true &&
    value.displayOption !== TestAnswerFeedbackDisplayOption.perOption &&
    value.generalTypeFb === TestAnswerFeedbackType.validation &&
    isPro

  const hasAnswersInGroups = state?.destination?.some(
    (group) => group.items && group.items.length > 0,
  )

  return (
    <>
      {isPro && <EditableProMode customMode={customMode} mode={mode} setAppMode={setAppMode} />}
      {showSeparator && <Separator />}
      <Button
        disabled={!hasAnswersInGroups}
        name='startOver'
        onClick={() => setState({ startOver: true })}
        styleType='secondary'
      >
        <Icon name='otherReload' size={KitSize.XS} />
        {t('elements.testGrouping.actions.startOver')}
      </Button>
      <TestElementChangeStateActions<TestGroupingStateType>
        setState={setState}
        state={state}
        value={value}
      />
    </>
  )
}

export default TestGroupingEditorActions
